import { gql } from 'apollo-boost';
const SUBMIT_TEXT_QUERY = gql `
	query (
		$inputText: String!
		$excludedKeywords: String
		$includedDomains: [String]
		$excludedDomains: [String]
		$domainsNumber: Int
		$domainsGeo: [String]
		$domainsOutput: Int
		$secondsMin: Int
		$secondsMax: Int
		$cpmMin: Int
		$cpmMax: Int
		$ctrMin: Float
		$ctrMax: Float
		$formats: [String]
		$devices: [String]
		$clientLabel: String
		$minBid: Float
		$maxBid: Float
	) {
		linkifyText(
			inputText: $inputText
			excludedKeywords: $excludedKeywords
			includedDomains: $includedDomains
			excludedDomains: $excludedDomains
			domainsNumber: $domainsNumber
			domainsGeo: $domainsGeo
			domainsOutput: $domainsOutput
			secondsMin: $secondsMin
			secondsMax: $secondsMax
			cpmMin: $cpmMin
			cpmMax: $cpmMax
			ctrMin: $ctrMin
			ctrMax: $ctrMax
			formats: $formats
			devices: $devices
			clientLabel: $clientLabel
			minBid: $minBid
			maxBid: $maxBid
		) {
			status
			errorText
			runId
			runStatus
			runOutput
		}
	}
`;
const SUBMIT_RECOMMENDED_QUERY = gql `
	query ($inputText: String!, $clientLabel: String) {
		recommendedKeywords(inputText: $inputText, clientLabel: $clientLabel) {
			status
			errorText
			runId
			runStatus
			runOutput
		}
	}
`;
const GET_JOB_OUTPUT_QUERY = gql `
	query ($runId: Int!) {
		linkifyGetJobOutput(runId: $runId) {
			status
			errorText
			runId
			runStatus
			runOutput
		}
	}
`;
export { SUBMIT_TEXT_QUERY, GET_JOB_OUTPUT_QUERY, SUBMIT_RECOMMENDED_QUERY };
